<div class="words-container">
  <div
    cdkDropList
    cdkDropListOrientation="horizontal"
    #todoList="cdkDropList"
    cdkDropListSortingDisabled
    [cdkDropListData]="words"
    [cdkDropListConnectedTo]="[doneList]"
    class="word-list"
    (cdkDropListDropped)="drop($event)"
  >
    @for (item of words; track item) {
      <span class="word" cdkDrag> {{ item }}</span>
    }
  </div>
</div>

<div class="words-container">
  <div
    cdkDropList
    cdkDropListOrientation="horizontal"
    #doneList="cdkDropList"
    [cdkDropListData]="wordsDragged"
    [cdkDropListConnectedTo]="[todoList]"
    class="answer-word-list"
    (cdkDropListDropped)="drop($event)"
  >
    <div class="answer-line 1"></div>
    <div class="answer-line 2"></div>
    <div class="answer-line 3"></div>
    <div class="answer-line 4"></div>
    <div class="answer-line 5"></div>
    @for (item of wordsDragged; track item) {
      <span class="word" cdkDrag> {{ item }}</span>
    }
  </div>
</div>
